import MatchHistory from './MatchHistory';

export default MatchHistory;
